import React, { useState, useEffect } from 'react';
import { FormButton } from 'common';
import { useInput } from 'hooks';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import InputGroup from 'react-bootstrap/InputGroup';
import showIcon from 'images/show.png';
import hideIcon from 'images/hide.png';
import './verifyPasscodeForm.scss';

const VerifyPasscodeForm = ({ verify, selectedFactor, resend }) => {
  const requiredFields = ['passcode'];
  const { inputs, handleInputChange } = useInput();
  const [resendDisabled, setResendDisabled] = useState(true);
  const [maskPasscode, setMaskPasscode] = useState(true);

  useEffect(() => {
    const resendTimer = setTimeout(() => setResendDisabled(false), 30000);
    return () => clearTimeout(resendTimer);
  }, [resendDisabled]);

  const isCallFactor = selectedFactor.type === 'call';
  const isEmailFactor = selectedFactor.type === 'email';

  return (
    <div className="occu-form">
      <h4>Enter your one time passcode</h4>
      <h5>We are sending the code to the {isEmailFactor ? 'email' : 'number'} you selected.</h5>
      <h5>Please enter the {isCallFactor ? 'five' : 'six'} digit code you received.</h5>
      <Form
        onSubmit={(event) => {
          verify(inputs.passcode);
          event.preventDefault();
        }}
      >
        <Form.Group>
          <InputGroup>
            <Form.Control
              type={maskPasscode ? 'password' : 'text'}
              name="passcode"
              placeholder="one time passcode"
              onChange={(event) => {
                event.target.value = event.target.value.replace(/[^0-9]/g, '');
                handleInputChange(event);
              }}
              value={inputs.passcode}
              required
              minLength={isCallFactor ? 5 : 6}
              maxLength={isCallFactor ? 5 : 6}
              autoComplete="off"
            />
            <InputGroup.Append>
              <Button
                variant="light"
                onClick={() => {
                  setMaskPasscode(!maskPasscode);
                }}
              >
                <div style={{ height: 20, width: 20 }}>
                  {maskPasscode ? <Image src={showIcon} fluid /> : <Image src={hideIcon} fluid />}
                </div>
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </Form.Group>

        <FormButton reqLength={isCallFactor ? 5 : 6} requiredFields={requiredFields} submittedFields={inputs}>
          Continue
        </FormButton>

        <Form.Group>
          <Button
            disabled={resendDisabled}
            variant="occu-primary"
            block
            onClick={(event) => {
              setResendDisabled(true);
              resend();
              event.preventDefault();
            }}
          >
            Re-send Code
          </Button>
        </Form.Group>

        <Form.Group>
          <small>Note: It may take a minute to receive your code.</small>
        </Form.Group>
      </Form>
    </div>
  );
};

export { VerifyPasscodeForm };
